import React from 'react'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import { useParams } from 'react-router-dom'
import { useGetProfiles } from '../../MyBookings/hooks/useGetProfiles'
import { capitalize, extractResponse } from '../../../utils'

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: '#FFFEFE',
        padding: theme.spacing(1),
        [theme.breakpoints.up('sm')]: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
    },
    headerContent: {
        display: 'flex',
        justifyContent: 'space-between',
        [theme.breakpoints.up('sm')]: {
            justifyContent: 'flex-start',
            gap: theme.spacing(3),
        },
        alignItems: 'center',
        width: '100%',
    },
    title: {
        margin: '0px',
        marginRight: theme.spacing(2),
        fontSize: '1.25rem',
        fontWeight: '500',
        display: 'inline',
    },
    subTitle: {
        fontSize: '1rem',
        [theme.breakpoints.up('sm')]: {
            fontSize: '1.25rem',
        },
    },

    headerWidth: {
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '80%',
            margin: 'auto',
        },
    },
}))

function Header() {
    const classes = useStyles()
    const { bookingId, status } = useParams()
    const { data } = useGetProfiles(bookingId, status)
    const numOfCandidates = extractResponse(data)?.data?.workers?.length || 0

    return (
        <div style={{ width: '100%', backgroundColor: '#ffffff' }}>
            <div className={classes.headerWidth}>
                <header className={classes.root}>
                    <div className={classes.headerContent}>
                        <Typography className={classes.title} component="p">
                            {capitalize(status)}
                        </Typography>
                        <Typography className={classes.subTitle} component="p" color="textSecondary">
                            {`${numOfCandidates} ${numOfCandidates === 1 ? 'worker' : 'workers'}`}
                        </Typography>
                    </div>
                </header>
            </div>
        </div>
    )
}

export default Header
